import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import ResumeParser from './ResumeParserApp';
import InterviewQuestions from './InterviewQuestionsApp';

export default function ResumeParserApp() {
  return (
    <AppLayout>
      <Routes>
        <Route path="interview-questions" element={<InterviewQuestions />} />
        <Route index element={<ResumeParser />} />
      </Routes>
    </AppLayout>
  );
}
